import React from 'react';
import PropTypes from 'prop-types';
import {
  AriaLiveRegion,
  Button,
  getTranslation,
  Icon,
  Image,
  TranslationProvider,
} from '@resy/ui-kitchen';

import reservationShape from '../ConfirmationPage/reservationShape';
import Person from '../../../../../ui-kitchen/src/svg/icons/person.svg';
import AddIcon from '../../../../../ui-kitchen/src/svg/icons/ic_add_20x20.svg';
import './GuestInvite.scss';

class GuestInvite extends React.Component {
  static propTypes = {
    ariaLiveText: PropTypes.string,
    copyLink: PropTypes.func.isRequired,
    party: PropTypes.arrayOf(PropTypes.shape({
      status: PropTypes.string,
      token: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      profile_image_url: PropTypes.string,
    })).isRequired,
    renderRemoveGuestModal: PropTypes.func.isRequired,
    renderRemoveSelfModal: PropTypes.func.isRequired,
    reservation: reservationShape.isRequired,
    showDeclineModal: PropTypes.bool.isRequired,
    showRemoveGuestModal: PropTypes.bool.isRequired,
    toggleRemoveGuestModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    ariaLiveText: '',
  }

  getGuestInitials = (guest) => {
    const firstInitial = guest.first_name[0];
    const lastInitial = guest.last_name[0];
    return (
      <div className="confirmed-guest__background confirmed-guest__background--no-img">
        <span className="confirmed-guest__initials">
          {`${firstInitial}${lastInitial}`}
        </span>
      </div>
    );
  }

  renderGuest = (guest = {}) => {
    const {
      copyLink,
      reservation,
      toggleRemoveGuestModal,
    } = this.props;

    const isHost = reservation.attendee?.type === 'host';
    const isConfirmedGuest = guest?.status !== 'uninvited';
    const label = (
      <TranslationProvider translationKey="guest">
        <div className="guest-name">Guest</div>
      </TranslationProvider>
    );

    if (!isConfirmedGuest && isHost) {
      return (
        <Button
          onClick={/* istanbul ignore next */ () => copyLink('Confirmation - unconfirmed')}
          variant="no-style"
          className="confirmed-guest"
          key={guest.token}
          aria-label={getTranslation({ translationKey: 'unknown_guest_aria_label', fallback: 'Unknown Guest, click to copy invite link' })}
          disabled={reservation.pastOrFuture !== 'future'}
        >
          <div className="add-guest-background">
            <Icon
              component={AddIcon}
              fill="#737373"
              name="add"
            />
          </div>
          {label}
        </Button>
      );
    } if (!isConfirmedGuest && !isHost) {
      return (
        <div className="GuestInvite__unconfirmed--guest">
          <Icon
            component={Person}
            height="64px"
            width="64px"
            name="person"
            fill="#737373"
          />
          {label}
        </div>
      );
    }

    const isDisabled = !isHost || reservation.pastOrFuture !== 'future' || (reservation.attendee.token !== guest.token && !isHost);
    const showHostLabel = reservation.attendee.type === 'guest' && guest.type === 'host';

    let ariaLabel = guest.first_name;
    if (!isDisabled) {
      const removeGuestLabel = getTranslation({
        translationKey: 'remove_guest',
        fallback: 'Remove guest',
      });
      ariaLabel = `${ariaLabel}, ${removeGuestLabel}`;
    }

    return (
      <Button
        onClick={/* istanbul ignore next */ () => toggleRemoveGuestModal(guest)}
        variant="no-style"
        className="confirmed-guest"
        key={guest.token}
        aria-label={ariaLabel}
        disabled={isDisabled}
      >
        {guest.profile_image_url
          ? (<Image src={guest.profile_image_url} className="confirmed-guest__background" />)
          : this.getGuestInitials(guest)}
        <span
          className="GuestInvite__guest-name"
          key={`guest-name-${guest.token}`}
          id={`guest-name-${guest.token}`}
          data-dd-privacy={showHostLabel ? 'mask' : undefined}
        >
          {guest.first_name}
          {showHostLabel
            && (
              <TranslationProvider translationKey="host">
                <div className="GuestInvite__host-label">Host</div>
              </TranslationProvider>
            )}
        </span>
      </Button>
    );
  }

  render() {
    const {
      ariaLiveText,
      party,
      renderRemoveGuestModal,
      renderRemoveSelfModal,
      showDeclineModal,
      showRemoveGuestModal,
    } = this.props;

    if (!party) {
      return null;
    }

    return (
      <div className="GuestInvite">
        {showDeclineModal && renderRemoveSelfModal()}
        {showRemoveGuestModal && renderRemoveGuestModal()}
        <AriaLiveRegion>
          {ariaLiveText}
        </AriaLiveRegion>
        <div className="GuestInvite__party">
          {party.map(this.renderGuest)}
        </div>
      </div>
    );
  }
}
export default GuestInvite;
